enum ProgressStepsEnum {
  EMPTY = 'EMPTY',
  DONE = 'DONE',
  DONE_UNKNOWN = 'DONE_UNKNOWN',
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
}

export default ProgressStepsEnum;
